
export const renderSolicitud = (status) => {
    switch (status) {
        case 1:
            return 'card'
            break;
        case 2:
            return 'card'
            break;
        case 3:
            return 'card'
            break;
        case 4:
            return 'card '
            break;
        case 5:
            return 'card'
            break;
        case 6:
            return 'card'
            break;
        default: 'card'
            break;
    }

}

export const renderTipoSolicitud = (tipo) => {
    switch (tipo) {
        case 1: return 'Informe de Cumplimiento Normal de Instalaciones Producción'; break;
        case 2: return 'Informe de Cumplimiento Normal de Instalaciones Almacén'; break;
        case 3: return 'Informe de Cumplimiento Normal de Instalaciones Envasado'; break;
        case 4: return 'Verificación de domicilio'; break;
        case 5: return 'Registro de Producción'; break;
        default:
            break;
    }
}

export const colorByStatusSolicitud = (status) => {
    /*
        1.- Solicitud asignada al inspector
        1.- si no ha pasado el inspector: pendiente inspeccion.
        2.- si ya paso el inspector: informe emitido.
        3.- si esta en proceso de revision del informe: informe en revisión.
        4.- Si ya lo reviso el gerente: dictamen emitido.
        5.- Cuando se finalize todo el proceso: Solictud atendida
        6.- Dictamen Rechazado
    */
    switch (status) {
        case 1:
            return '#EAECEE'
            break;
        case 2:
            return '#FCF3CF'
            break;
        case 3:
            return '#FAD7A0'
            break;
        case 4:
            return '#AED6F1'
            break;
        case 5:
            return '#A9DFBF'
            break;
        case 6:
            return '#EC7070'
            break;
        default: '#EAECEE'
            break;
    }

}

